export default "__VITE_ASSET__D3U6Xuae__"